import { GridColDef } from "@mui/x-data-grid";
import { NavigateFunction } from "react-router-dom";
import { columnsAnalysis, columnsEfficiency } from "./calibration.columns";
import FilterCalibrationEfficiency from "../components/filters/filterCalibrationEfficiency";
import FilterCalibrationAnalysis from "../components/filters/filterCalibrationAnalysis";

export const setsConfigCalibration = (
  handleDelete: (params: any) => () => void,
  navigate: NavigateFunction
): {
  label: string;
  set: string;
  columns: GridColDef[];
  filterComponent: React.ElementType;
}[] => [
  {
    label: "Eficiencia",
    set: "eficiencia",
    columns: columnsEfficiency(handleDelete, navigate),
    filterComponent: FilterCalibrationEfficiency,
  },
  {
    label: "Análisis",
    set: "analisis",
    columns: columnsAnalysis(handleDelete, navigate),
    filterComponent: FilterCalibrationAnalysis,
  },
];

export const setsConfigAnalysisTabs: {
  label: string;
  set: string;
}[] = [
  {
    label: "Datos tritio",
    set: "tritio",
  },
  {
    label: "Curva de ajuste para factor de autoabsorción",
    set: "curva",
  },
];

export const setsConfigAlfaTabs: {
  label: string;
  set: string;
}[] = [
  {
    label: "Datos Alfa",
    set: "alfa",
  },
  {
    label: "Curva de ajuste para factor de autoabsorción",
    set: "curva",
  },
];

export const setsConfigAnalysisFe55Tabs: {
  label: string;
  set: string;
}[] = [
  {
    label: "Datos Fe55",
    set: "tritio",
  },
  {
    label: "Curva de ajuste para factor de autoabsorción",
    set: "curva",
  },
];

export const setsConfigAnalysisNi63Tabs: {
  label: string;
  set: string;
}[] = [
  {
    label: "Datos Ni63",
    set: "tritio",
  },
  {
    label: "Curva de ajuste para factor de autoabsorción",
    set: "curva",
  },
];

export const setsConfigBetaTabs: {
  label: string;
  set: string;
}[] = [
  {
    label: "Datos beta",
    set: "beta",
  },
  {
    label: "Curva de ajuste para factor de autoabsorción",
    set: "curva",
  },
  {
    label: "Determinación spill-over (SO)",
    set: "spillOver",
  },
  {
    label: "Datos K-40",
    set: "K40",
  },
  {
    label: "Curva de Ajuste para factor de autoabsorción K-40",
    set: "curvaK40",
  },
];

export const setConfigSpectrometryAlfaTabs: {
  label: string;
  set: string;
}[] = [
  {
    label: "Fuente Patrón",
    set: "spectrometryAlfa",
  },
  {
    label: "Detectores",
    set: "spectrometryAlfaDetectors",
  },
];

export enum EFFICIENCY_TYPE {
  Gamma = "Gamma",
  AlfaBeta = "Contadores proporcionales Alfa-Beta",
  LiquidScintillation = "Centelleo líquido",
}

export const MOCK_EFFICIENCY_TYPE = [
  { type: EFFICIENCY_TYPE.Gamma },
  { type: EFFICIENCY_TYPE.AlfaBeta },
  { type: EFFICIENCY_TYPE.LiquidScintillation },
];

export const COEFFICIENTS_DECIMALS = 8;
